import {BeanCategoryGroup} from './BeanCategoryGroup'
import { BeanMonitoryParameter } from './BeanMonitoryParameter'
import {BeanParameter} from './BeanParameter'
import { BeanParametroXMotivo } from './BeanParametroXMotivo'

export class BeanFormulario {
    constructor(
        public formIdCdFormulario: number,
        public formDsFormulario: string,
        public formDsVersao: string,
        public formDhInativo: string,
        public formDhRegistro: string,
        public formDsSegmento: string,
        public formInTipo: string,
        public operIdCdOperacao: number,
        public parameters: BeanParameter[],
        public parametersMotivos: BeanParametroXMotivo[],
        public categoryGroups: BeanCategoryGroup[],
        public formDsTipoPontuacao: string, // SOMA ou MÉDIA
        
    ){} 
}